const ls = {
  set(key, value) {
    let res = typeof value == 'object' ? JSON.stringify(value) : value;
    return localStorage.setItem(key, res);
  },
  get(key) {
    let res = localStorage.getItem(key);
    try {
      res = JSON.parse(res);
    } catch {
    
    }
    return res;
  },
  remove(key) {
    if (Array.isArray(key)) {
      key.forEach((item) => {
        localStorage.removeItem(item);
      });
    } else {
      localStorage.removeItem(key);
    }
  },
  setCartList(cartList) {
    return ls.set('MALLCARTLIST', cartList);
  },
  getCartList() {
    return ls.get('MALLCARTLIST');
  },
  setConfirmGoodsList(goodsList) {
    return ls.set('CONFIRMGOODSLIST', goodsList);
  },
  getConfirmGoodsList() {
    return ls.get('CONFIRMGOODSLIST');
  }
};

export default ls;
